import PropTypes from 'prop-types'
import { Tab, Tabs } from 'baseui/tabs-motion'
import Client from './Tabs/Client'
import useSubscriptionForm from './useSubscriptionForm'
import MeterIds from './Tabs/MeterIds'
import { Delete } from 'baseui/icon'
import useTabBar from './useTabBar'
import useTabBarStyle from './useTabBarStyle'
import SaleForm from '../Layouts/SaleForm'
import { ErrorBoundary } from 'react-error-boundary'
import { Suspense } from 'react'
import Addresses from './Tabs/Addresses'
import CreditBooster from '@/containers/SubscriptionFormPageNew/Components/CreditBooster/CreditBooster'
import CreateContractModal from '@/containers/SubscriptionFormPageNew/Components/CreateContractModal/CreateContractModal'
import HistoricSales from '@/containers/SubscriptionFormPageNew/Components/HistoricSales/HistoricSales'
import { Button } from 'baseui/button'
import useCreateContractModal from '../Components/CreateContractModal/useCreateContractModal'
import AdditionalSalesContainer from '../Components/AdditionalSales/AdditionalSalesContainer'
import Distributor from '@/containers/SubscriptionFormPageNew/Components/Distributor/Distributor'
import CommunicationBoard from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/CommunicationBoard'
import ScheduleCallback from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/ScheduleCallback'
import Tools from '@/containers/SubscriptionFormPageNew/Components/Tools/Tools'
import Resources from '../Components/Resources/Resources'

const SubscriptionForm = ({ country, id }) => {
  const { activeTab, openedContracts, existingContracts, removeFromOpenedContracts, updateActiveTabHandler, t } =
    useTabBar()
  const {
    tabStyle,
    tabsOverrides,
    mainContainerStyle,
    tabsContainerStyle,
    rightColumnContainerStyle,
    rightColumnElementStyle,
    rightColumnElementStatelessStyle,
    addButtonStyle,
  } = useTabBarStyle()

  const { toggleContractModal } = useCreateContractModal()

  useSubscriptionForm(id)

  return (
    <div style={mainContainerStyle}>
      <CreateContractModal />
      <div style={tabsContainerStyle}>
        <Tabs
          activeKey={activeTab}
          onChange={({ activeKey }) => updateActiveTabHandler(activeKey)}
          overrides={tabsOverrides}
          endEnhancer={
            <Button
              onClick={event => {
                event.preventDefault()
                toggleContractModal()
              }}
              overrides={addButtonStyle}
            >
              {t('subscriptionForm:contract_modal.tab_title')}
            </Button>
          }
        >
          <Tab title={t('common:client')} key='client' overrides={tabStyle}>
            <Client />
            <Addresses />
            <MeterIds />
          </Tab>
          {openedContracts.length > 0 &&
            openedContracts.map(contractId => {
              const contract = existingContracts[contractId]
              if (!contract) {
                return null
              }

              const contractKey = contract.id + '-' + contract.type
              return (
                <Tab
                  key={contractKey}
                  artwork={() => (
                    <Delete
                      onClick={e => {
                        e.stopPropagation()
                        removeFromOpenedContracts({ id: contract.id, type: contract.type })
                      }}
                    />
                  )}
                  title={`${t(`common:${contract.type}`)} ${contract.id}`}
                  overrides={tabStyle}
                >
                  <div style={{ width: '100%', maxWidth: '100%', display: 'flex', flexGrow: 1 }}>
                    <ErrorBoundary fallback={<p>{t('common:error_contact_support')}</p>}>
                      <Suspense fallback={<div>{t('common:loading')}</div>}>
                        <SaleForm country={country} type={contract.type} />
                      </Suspense>
                    </ErrorBoundary>
                  </div>
                </Tab>
              )
            })}
          <Tab title={t('additionalSales:common.tab_title')} key='additional-sales' overrides={tabStyle}>
            <AdditionalSalesContainer />
          </Tab>
        </Tabs>
      </div>
      <div style={rightColumnContainerStyle}>
        <div key='callback-module' style={{ width: '100%' }}>
          <ScheduleCallback version='v2' />
        </div>
        <div key='resources-module' style={rightColumnElementStatelessStyle}>
          <Resources country={country} />
        </div>
        <div key='credit-booster-module' style={rightColumnElementStatelessStyle}>
          <CreditBooster country={country} />
        </div>
        <div key='communication-board-module' style={rightColumnElementStatelessStyle}>
          <CommunicationBoard />
        </div>
        <div key='distributor-module' style={rightColumnElementStatelessStyle}>
          <Distributor />
        </div>
        <div key='historic-sales-module' style={rightColumnElementStyle}>
          <HistoricSales />
        </div>
        <div key='tools-module' style={rightColumnElementStatelessStyle}>
          <Tools />
        </div>
      </div>
    </div>
  )
}

SubscriptionForm.propTypes = {
  id: PropTypes.string,
  country: PropTypes.string,
}

export default SubscriptionForm
